export class LocalizedString {
  public 'en-US': string;
  public 'en-CA': string;
  public 'en-GB': string;
  public de: string;
  public es: string;
  public fr: string;
  public 'fr-CA': string;
  public it: string;
  public ja: string;
  public pt: string;
  public 'zh-CN': string;
  public nl: string;
  public nb: string;
  public da: string;
  public ko: string;
  public sv: string;

  constructor() {
    this['en-US'] = '';
    this['en-CA'] = '';
    this['en-GB'] = '';
    this.de = '';
    this.es = '';
    this.fr = '';
    this.it = '';
    this.ja = '';
    this.pt = '';
    this['zh-CN'] = '';
    this['fr-CA'] = '';
    this.nl = '';
    this.nb = '';
    this.da = '';
    this.ko = '';
    this.sv = '';
  }
}
